import React, { useEffect, useRef } from 'react';
import '../css/ConfirmModal.css';
import { useLabels } from '../config/labelsContext';

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title: titleProp,
  message,
  confirmLabel: confirmLabelProp,
  cancelLabel: cancelLabelProp,
  destructive = true,
  onConfirm,
  onCancel,
}) => {
  const { labels } = useLabels();
  const title = titleProp ?? labels.modals.confirmDefaultTitle;
  const confirmLabel = confirmLabelProp ?? labels.modals.confirmDeleteButton;
  const cancelLabel = cancelLabelProp ?? labels.modals.confirmCancelButton;
  const confirmBtnRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!open) return;
    // Focus primary action for keyboard users.
    window.setTimeout(() => confirmBtnRef.current?.focus(), 0);
  }, [open]);

  if (!open) return null;

  return (
    <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
      <div className="confirm-modal-content">
        <div className="confirm-modal-header">
          <h3 className="confirm-modal-title">{title}</h3>
        </div>
        <div className="confirm-modal-body">
          <p className="confirm-modal-message">{message}</p>
        </div>
        <div className="confirm-modal-footer">
          <button type="button" className="confirm-modal-cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            ref={confirmBtnRef}
            type="button"
            className={`confirm-modal-confirm${destructive ? ' is-destructive' : ''}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
